import * as React from "react";
import { Icon } from "semantic-ui-react";
import { Connection, Device } from "twilio-client";

export interface ITwilioConferenceProps {
  roomName: string;
  queryName: string;
  getToken: (c: (s: firebase.database.DataSnapshot) => void) => void;
}

const TwilioConference: React.FC<ITwilioConferenceProps> = ({
  roomName,
  queryName,
  getToken,
}) => {
  const [called, setCalled] = React.useState(false);
  const [connection, setConnection] = React.useState(null);

  const handlePhoneClick = () => {
    if (called) {
      endCall();
    } else {
      getToken((requestSnapshot: firebase.database.DataSnapshot) => {
        const thisToken = requestSnapshot.val();
        if (thisToken && thisToken.token && thisToken.token.val) {
          startCall(thisToken.token.val);
        }
      });
    }
  };

  /*
    connection.disconnect();

    const preflightTest = Device.runPreflight(token, { debug: true });
    preflightTest.on(PreflightTest.Events.Completed, (report) => {
      console.log(report);
    });

    preflightTest.on(PreflightTest.Events.Failed, (error) => {
      console.log(error);
    });
  */

  const startCall = (t: string) => {
    const device = new Device();
    let conn: Connection;
    device.setup(t, {
      debug: true,
      enableIceRestart: true,
      closeProtection: true,
    });
    device.on(Device.EventName.Ready, () => {
      const params = {
        roomName,
        queryName,
      };
      conn = device.connect(params);
      setCalled(true);
      setConnection(conn);
      conn.on("disconnect", () => {
        setCalled(false);
        device.destroy();
      });
    });

    device.on(Device.EventName.Offline, (...args) => {
      console.log("offline", args);
      alert("Call got disconnected");
    });

    device.on(Device.EventName.Error, (error) => {
      device.destroy();
      setCalled(false);
      console.log(error.message);
      console.log(error.twilioError);
    });
  };

  const endCall = () => {
    if (connection) {
      connection.disconnect();
    }
  };

  return (
    <div>
      <Icon
        circular={true}
        inverted={true}
        color={called ? "red" : "green"}
        link={true}
        name="phone"
        size="small"
        onClick={handlePhoneClick}
        style={{ position: "absolute", zIndex: 12, right: "12px" }}
        className={called ? "phone-call" : ""}
      />
    </div>
  );
};

export default TwilioConference;



// WEBPACK FOOTER //
// ./src/components/Query/TwilioConference.tsx